export const InitialState = {
  hamburgerOpen: false,
  isMobile: false,
  isModalOpen: false,
  isLoadingData: true,
  error: {
    origin: null,
    message: null,
  },
  activeId: null,
};

export const actionTypes = {
  SET_HAMBURGER_OPEN: "SET_HAMBURGER_OPEN",
  SET_IS_MOBILE: "SET_IS_MOBILE",
  SET_IS_MODAL_OPEN: "SET_IS_MODAL_OPEN",
  SET_ERROR: "SET_ERROR",
  SET_IS_LOADING_DATA: "SET_IS_LOADING_DATA",
  SET_ACTIVE_ID: "SET_ACTIVE_ID",
};

export const Reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_IS_LOADING_DATA:
      return {
        ...state,
        isLoadingData: action.payload,
      };
    case actionTypes.SET_HAMBURGER_OPEN:
      return {
        ...state,
        hamburgerOpen: action.payload,
      };
    case actionTypes.SET_IS_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: action.payload,
      };
    case actionTypes.SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case actionTypes.SET_ACTIVE_ID:
      return {
        ...state,
        activeId: action.payload,
      };
    case actionTypes.SET_ERROR:
      return {
        ...state,
        error: {
          origin: action.payload.origin,
          message: action.payload.message,
        },
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
